import BillsDiscoveryAccounts from '../../../bills/components/BillsDiscoveryAccounts';

export default function BillsDiscoveryAccountsScreen() {
    return <BillsDiscoveryAccounts screenContext="initialDiscovery" />;
}
